// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CopilotUpsellContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-copilotupsellcontainer" */ "./CopilotUpsellContainer")).then((bundle)=>{
        return {
            default: bundle.CopilotUpsellModalContainer
        };
    });
export const LazyCopilotUpsellContainer = /*#__PURE__*/ lazy(CopilotUpsellContainerLazyLoader);
